<template>
  <div>
    <el-dialog title="推荐点贡献统计" :visible.sync="visible" width="860px" :close-on-click-modal="false" append-to-body
      @closed="onClosed">
      <div class="stats-toolbar">
        <span class="label">创建日期：</span>
        <el-date-picker v-model="timeRange" type="daterange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="datePickerOptions"
          :size="size" style="width: 340px" />
        <el-button type="primary" :size="size" :loading="loading" style="margin-left: 12px" @click="load">
          汇总查询
        </el-button>
      </div>

      <div class="stats-toolbar row2">
        <span class="label">按人查明细：</span>
        <el-select v-model="creatorSelectedName" filterable clearable placeholder="请选择创建人" :size="size"
          style="width: 280px">
          <el-option v-for="u in adminOptions" :key="u.id" :label="formatAdminLabel(u)" :value="u.name" />
        </el-select>
        <el-button type="default" :size="size" style="margin-left: 8px" @click="openDetailFromSelect">
          查 TA 的推荐点
        </el-button>
      </div>



      <div class="stats-filter-row">
        <el-input v-model="keyword" clearable placeholder="汇总表按创建人筛选" prefix-icon="el-icon-search" :size="size"
          style="width: 240px" />
        <span v-if="tableRows.length" class="meta">
          当前 {{ filteredRows.length }} 人，合计 {{ filteredTotal }} 条
        </span>
      </div>

      <el-table v-loading="loading" :data="filteredRows" stripe border :size="size" max-height="380" empty-text="暂无数据">
        <el-table-column type="index" label="#" width="52" align="center" />
        <el-table-column prop="createUser" label="创建人" min-width="160" show-overflow-tooltip />
        <el-table-column prop="count" label="推荐点数" width="100" align="right" sortable :sort-method="sortByCount" />
        <el-table-column label="操作" width="88" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" :size="size" @click="openDetail(scope.row.createUser)">明细</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer">
        <el-button :size="size" @click="visible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'推荐点明细 — ' + detailUser" :visible.sync="detailVisible" width="960px"
      :close-on-click-modal="false" append-to-body custom-class="rec-point-detail-dialog" @closed="onDetailClosed">
      <div class="detail-actions">
        <el-button type="primary" :size="size" :loading="detailLoading" @click="loadDetail">刷新</el-button>
        <span
          class="detail-hint">与汇总统计口径一致：仅<strong>第一层</strong>推荐点；汇总/明细均按<strong>区域创建时间</strong>落在所选日期范围内筛选，表中「创建时间」列仍为各推荐点自身创建时间。</span>
      </div>
      <el-table v-loading="detailLoading" :data="detailRows" stripe border :size="size" max-height="480"
        empty-text="暂无数据" style="width: 100%">
        <el-table-column type="index" label="#" width="48" align="center" fixed />
        <el-table-column prop="areaName" label="区域名称" min-width="120" show-overflow-tooltip />
        <el-table-column label="路线" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.pathId | pathNameTransfer }}
          </template>
        </el-table-column>
        <el-table-column label="区域侧" width="88" align="center">
          <template slot-scope="scope">
            {{ formatIsStart(scope.row.isStart) }}
          </template>
        </el-table-column>
        <el-table-column prop="pointName" label="推荐点名称" min-width="120" show-overflow-tooltip />
        <el-table-column label="经纬度" min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatLatLng(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="price" label="加价(分)" width="88" align="right">
          <template slot-scope="scope">
            {{ scope.row.price != null ? scope.row.price : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="createReason" label="创建原因" min-width="100" show-overflow-tooltip />
        <el-table-column label="订单类型" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.limitOrderType | enumTransfer(orderTypeOpts, "value", "label") }}
          </template>
        </el-table-column>
        <el-table-column label="起/终点推荐" width="100" align="center">
          <template slot-scope="scope">
            {{ formatDepOrDest(scope.row.depOrDest) }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="156">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormat("yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button :size="size" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { statsRecPointsByCreator, listRecPointsByCreator } from "@/api";
import { getAdminList } from "@/api/admin";

export default {
  name: "RecPointStatsDialog",

  data() {
    const rangeShortcut = (daysBackStart, endMoment = moment()) => {
      const start = moment().subtract(daysBackStart, "days").startOf("day").toDate();
      const end = endMoment.clone().endOf("day").toDate();
      return [start, end];
    };
    return {
      visible: false,
      loading: false,
      timeRange: [],
      keyword: "",
      tableRows: [],
      creatorSelectedName: "",
      /** 与 WorkFlow 页「创建人」同源：getAdminList（不含「系统」项） */
      adminOptions: [],
      detailVisible: false,
      detailLoading: false,
      detailUser: "",
      detailRows: [],
      datePickerOptions: {
        shortcuts: [
          {
            text: "最近1个星期",
            onClick(picker) {
              picker.$emit("pick", rangeShortcut(6));
            }
          },
          {
            text: "最近半个月",
            onClick(picker) {
              picker.$emit("pick", rangeShortcut(14));
            }
          },
          {
            text: "最近1个月",
            onClick(picker) {
              const end = moment().endOf("day").toDate();
              const start = moment().subtract(1, "month").startOf("day").toDate();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近3个月",
            onClick(picker) {
              const end = moment().endOf("day").toDate();
              const start = moment().subtract(3, "months").startOf("day").toDate();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近半年",
            onClick(picker) {
              const end = moment().endOf("day").toDate();
              const start = moment().subtract(6, "months").startOf("day").toDate();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近1年",
            onClick(picker) {
              const end = moment().endOf("day").toDate();
              const start = moment().subtract(1, "year").startOf("day").toDate();
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },

  computed: {
    ...mapState({
      size: (state) => state.btnSize,
      orderTypeOpts: (state) => state.enumMap["ORDER_TYPE"] || []
    }),
    filteredTotal() {
      return this.filteredRows.reduce((s, r) => s + (Number(r.count) || 0), 0);
    },
    filteredRows() {
      const k = (this.keyword || "").trim().toLowerCase();
      if (!k) {
        return this.tableRows;
      }
      return this.tableRows.filter((r) => (r.createUser || "").toLowerCase().includes(k));
    }
  },

  methods: {
    show() {
      this.keyword = "";
      this.creatorSelectedName = "";
      this.resetDefaultRange();
      this.loadAdminList();
      this.visible = true;
      this.$nextTick(() => this.load());
    },

    resetDefaultRange() {
      const end = moment().format("YYYY-MM-DD");
      const start = moment().subtract(6, "days").format("YYYY-MM-DD");
      this.timeRange = [start, end];
    },

    onClosed() {
      this.tableRows = [];
      this.keyword = "";
      this.creatorSelectedName = "";
      this.adminOptions = [];
      this.detailVisible = false;
      this.detailRows = [];
      this.detailUser = "";
    },

    onDetailClosed() {
      this.detailRows = [];
    },

    sortByCount(a, b) {
      return (Number(a.count) || 0) - (Number(b.count) || 0);
    },

    getQueryTimeRangeOrWarn() {
      if (!this.timeRange || this.timeRange.length !== 2) {
        this.$message.warning("请先选择统计日期范围");
        return null;
      }
      const [startDate, endDate] = this.timeRange;
      return {
        startTime: `${startDate} 00:00:00`,
        endTime: `${endDate} 23:59:59`
      };
    },

    formatAdminLabel(u) {
      return `${u.name || ""}`;
    },

    loadAdminList() {
      const param = {
        page: { size: 500 },
        param: {
          normalUser: true
        }
      };
      getAdminList(param).then((res) => {
        this.adminOptions = res.data.records || [];
      });
    },

    load() {
      const range = this.getQueryTimeRangeOrWarn();
      if (!range) return;
      this.loading = true;
      statsRecPointsByCreator(range)
        .then((res) => {
          const map = res.data || {};
          const rows = Object.keys(map)
            .map((createUser) => ({
              createUser,
              count: map[createUser]
            }))
            .sort((a, b) => (Number(b.count) || 0) - (Number(a.count) || 0));
          this.tableRows = rows;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openDetailFromSelect() {
      const u = (this.creatorSelectedName || "").trim();
      if (!u) {
        this.$message.warning("请选择创建人");
        return;
      }
      this.openDetail(u);
    },

    openDetail(createUser) {
      const range = this.getQueryTimeRangeOrWarn();
      if (!range) return;
      const u = (createUser || "").trim();
      if (!u) {
        this.$message.warning("创建人不能为空");
        return;
      }
      this.detailUser = u;
      this.creatorSelectedName = u;
      this.detailVisible = true;
      this.$nextTick(() => this.loadDetail());
    },

    loadDetail() {
      const range = this.getQueryTimeRangeOrWarn();
      if (!range || !this.detailUser) return;
      this.detailLoading = true;
      listRecPointsByCreator({
        createUser: this.detailUser,
        startTime: range.startTime,
        endTime: range.endTime
      })
        .then((res) => {
          this.detailRows = res.data || [];
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },

    formatIsStart(v) {
      if (v === true) return "起点";
      if (v === false) return "终点";
      return "-";
    },

    formatDepOrDest(vals) {
      if (!vals || !vals.length) return "-";
      const map = { 1: "起点", 2: "终点" };
      return vals.map((x) => map[x] != null ? map[x] : x).join("、");
    },

    formatLatLng(row) {
      const { lat, lng } = row || {};
      if (lat == null && lng == null) return "-";
      return `${lat || "-"}, ${lng || "-"}`;
    }
  }
};
</script>

<style scoped lang="less">
.stats-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;

  &.row2 {
    margin-bottom: 12px;
  }

  .label {
    margin-right: 4px;
    color: #606266;
    font-size: 14px;
    flex-shrink: 0;
  }
}

.stats-tip {
  margin-bottom: 12px;
}

.stats-filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  .meta {
    color: #909399;
    font-size: 13px;
  }
}

.detail-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;

  .detail-hint {
    color: #909399;
    font-size: 13px;
    line-height: 1.5;
  }
}
</style>
